import { useMemo } from 'react';
import { idsToInteractions } from '@embed/components/VideoPlayer/Player3/components/Interactions/helpers';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { currentLiveStreamIdSelector, highlightedEntitiesSelector, liveStreamInteractionsSelector, } from '@embed/components/VideoPlayer/Player3/store/selectors';
/**
 * Returns the currently highlighted link interactions
 */
export function useLinkInteractions() {
    const liveStreamId = useStore(currentLiveStreamIdSelector);
    const highlightedLinkEntities = useStore((state) => highlightedEntitiesSelector(state, liveStreamId, 'link'));
    const linkInteractions = useStore((state) => liveStreamInteractionsSelector(state, liveStreamId, 'link'));
    return useMemo(() => idsToInteractions(highlightedLinkEntities?.map((hle) => hle.entity_id), linkInteractions), [linkInteractions, highlightedLinkEntities]);
}
